import { Centrifuge, ServerPublicationContext } from 'centrifuge'
import { api } from '@/lib/api'

const WS_URL = import.meta.env.VITE_CENTRIFUGO_URL || 'wss://ws.proximatool.dev/connection/websocket'

let client: Centrifuge | null = null
let tokenPromise: Promise<string> | null = null

async function fetchToken(): Promise<string> {
  const res = await api.getCentrifugoToken()
  return res.token
}

export function getCentrifuge(): Centrifuge {
  if (!client) {
    client = new Centrifuge(WS_URL, {
      debug: false,
      getToken: () => {
        if (!tokenPromise) {
          tokenPromise = fetchToken()
        }
        return tokenPromise
      },
    })
    client.on('error', () => {
      tokenPromise = null
    })
    client.connect()
  }
  return client
}

type Listener = (data: any) => void
const listeners = new Map<string, Set<Listener>>()
let initialized = false

function ensurePublicationListener() {
  if (initialized) return
  initialized = true
  getCentrifuge().on('publication', (ctx: ServerPublicationContext) => {
    const set = listeners.get(ctx.channel)
    if (set) {
      for (const fn of set) {
        fn(ctx.data)
      }
    }
  })
}

export async function subscribe(channel: string, onData: Listener): Promise<() => void> {
  ensurePublicationListener()

  if (!listeners.has(channel)) {
    listeners.set(channel, new Set())
  }
  listeners.get(channel)!.add(onData)

  await api.centrifugoSubscribe(channel)

  return () => {
    const set = listeners.get(channel)
    if (set) {
      set.delete(onData)
      if (set.size === 0) {
        listeners.delete(channel)
      }
    }
  }
}
